module.exports = __webpack_public_path__ + "static/media/png.5e5c0a3b.svg";